import classNames from 'classnames/bind'

import { observer } from 'mobx-react'

import { dateToString } from 'modules/core/lib/dates'

import type { TeamViewEmployee } from 'modules/calendar/components/TeamView'
import type Store from 'modules/calendar/components/TeamView/components/Store'

import Cell from './_Cell'
import styles from './index.module.scss'

const cx = classNames.bind(styles)
interface Props {
  store: Store
  employee: TeamViewEmployee
  day: number
  employeeWorkingDays: string
}

const DayCell = ({ store, employee, day, employeeWorkingDays }: Props) => {
  const dayLeaf = store.days[day]

  const companyHolidayLocationIds = dayLeaf
    ? store.companyHolidayLocationIdsByDate[dateToString(dayLeaf.date, 'backend')] ?? new Set()
    : new Set()

  const dayClasses: Record<string, boolean> = dayLeaf
    ? {
        ...dayLeaf.classes,
        companyHoliday:
          employee.locationId != null && companyHolidayLocationIds.has(employee.locationId),
      }
    : {}

  const dayName = dayLeaf?.date.locale('en').format('dddd').toLowerCase()

  const isNotWorking =
    !employeeWorkingDays || dayName === undefined ? false : !employeeWorkingDays.includes(dayName)

  const leaveEventLeaves = store.leaves[`${day}-${employee.id}`]

  const leaveClasses = {
    isNotWorking,
  }

  const className = cx('dayCell', dayClasses, leaveClasses)

  return (
    <td className={className}>
      {leaveEventLeaves &&
        leaveEventLeaves.map((leaveEventLeaf, index) => (
          <Cell
            key={`cell_${index}`}
            leaveEventLeaf={leaveEventLeaf}
            dayClasses={dayClasses}
            year={dayLeaf?.date.year()}
          />
        ))}
    </td>
  )
}

export default observer(DayCell)
